import { readable } from 'svelte/store';

function createMediaQueryReadable(queryString: string) {
  return readable(
    typeof window !== 'undefined' ? window.matchMedia(queryString).matches : false,
    (set) => {
      if (typeof window === 'undefined') {
        set(false);
        return;
      }

      const update = (event: { matches: boolean }) => {
        set(event.matches);
      };

      const mediaQueryList = window.matchMedia(queryString);
      mediaQueryList.addEventListener('change', update);

      return () => {
        mediaQueryList.removeEventListener('change', update);
      };
    },
  );
}

/**
 * @see lib/styles/breakpoints.css
 */

export const lessThanXs = createMediaQueryReadable('(max-width: 520px)');
export const xs = createMediaQueryReadable('(min-width: 520px)');
export const sm = createMediaQueryReadable('(min-width: 768px)');
export const md = createMediaQueryReadable('(min-width: 1024px)');
export const lg = createMediaQueryReadable('(min-width: 1280px)');
export const xl = createMediaQueryReadable('(min-width: 1640px)');
export const xxl = createMediaQueryReadable('(min-width: 1920px)');
